import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";
import { IMAGES } from "../constants";
import { Layers, AudioLines, FileMusic } from "lucide-react";

const CARDS = [
  {
    icon: Layers,
    title: "Recording Artist & Vocal Arranger",
    org: "Independent / Studio Projects",
    desc: "Composed, arranged, and recorded original contemporary inspirational catalog fusing 90s R&B sensibilities, Motown harmonic phrasing, and modern pop structure.",
  },
  {
    icon: AudioLines,
    title: "Studio Craft",
    org: "Session Skillset",
    desc: "Experienced with studio vocal layering, tight multi-track harmony stacking, and quick chart memorization.",
  },
];

const CHIPS = [
  { icon: FileMusic, label: "Vocal Layering" },
  { icon: AudioLines, label: "Multi-Track Harmony Stacking" },
  { icon: FileMusic, label: "Quick Chart Memorization" },
];

export default function Studio() {
  return (
    <section id="studio" className="relative py-24 lg:py-32" data-testid="studio-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
        <SectionHeading index="04" eyebrow="Studio Recording & Songwriting" title="In The Studio" />
        <div className="grid md:grid-cols-2 gap-6">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.1}>
              <div
                className="group relative h-full rounded-3xl border border-white/10 bg-white/[0.04] p-8 lg:p-10 transition-all duration-300 hover:border-hpink/40 hover:bg-white/[0.06]"
                data-testid={`studio-card-${i + 1}`}
              >
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-hpink/20 to-horange/20 border border-hpink/30 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <c.icon size={20} className="text-hpink" />
                </div>
                <h3 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">{c.title}</h3>
                <p className="mt-1.5 font-mono text-[11px] uppercase tracking-[0.25em] text-hblue">{c.org}</p>
                <p className="mt-5 text-hmut leading-relaxed">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.12} className="mt-6">
          <div
            className="relative h-72 lg:h-80 rounded-3xl overflow-hidden border border-white/10"
            data-testid="studio-photo-banner"
          >
            <img
              src={IMAGES.studioHeadphones}
              alt="Hulda Perez in the vocal booth"
              loading="lazy"
              className="duotone absolute inset-0 w-full h-full object-cover"
              style={{ objectPosition: "50% 38%" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-hpink/10 to-transparent" />
            <div className="absolute bottom-5 left-6 font-mono text-[10px] uppercase tracking-[0.3em] text-white/85">
              In the vocal booth
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="mt-8">
          <div className="flex flex-wrap gap-3">
            {CHIPS.map((c) => (
              <span
                key={c.label}
                className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-xs font-semibold text-white"
                data-testid="studio-skill-chip"
              >
                <c.icon size={13} className="text-horange" /> {c.label}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
